<template>
  <a-modal
    title="审批意见"
    :width="400"
    :visible="visible"
    :maskClosable="false"
    :closable="true"
    :footer="null"
    @cancel="reset"
  >
    <div class="textarea-area">
      <a-textarea v-model="textareaValue" :auto-size="{ minRows: 4, maxRows: 4 }" />
    </div>
    <div class="footer aj-center-end">
      <a-button type="primary" :loading="rejectLoading" @click="handleRefuse">驳回</a-button>
      <a-button type="primary" :loading="approvalLoading" class="ml8" @click="handleRatify">同意</a-button>
    </div>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import { apiKernelFlowExternalBpm } from '@/api/scp/reserve-goods-plan/reserve-plan-approval'
import md5 from 'md5'

// 表单字段
export default {
  props: {
    billNo: {
      type: [Number, String],
      default: null
    },
    processCoding: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      visible: false,
      textareaValue: "",
      approvalLoading: false,
      rejectLoading: false
    }
  },
  computed: {
    ...mapState({
      jobCode: (state) => state.user.jobCode
    })
  },
  created () {},
  methods: {
    show () {
      this.visible = true
    },
    // 表单重置
    reset () {
      this.textareaValue = ""
      this.visible = false
    },
    examineAndApprove (val) {
      const apiKey = process.env.VUE_APP_API_SCM_GYL_URL_api_key
      const apiSecret = process.env.VUE_APP_API_SCM_GYL_URL_api_secret
      const timestamp = new Date().getTime()
      const sign = md5(apiKey.toString() + timestamp.toString() + apiSecret.toString());
      const url = `${process.env.VUE_APP_API_SCM_GYL_URL}/api/kernel-flow/external/bpm/approveProcess?apiKey=${apiKey}&apiSecret=${apiSecret}&timestamp=${timestamp}&sign=${sign}`
      const params = {
        assignee: this.jobCode, // 当前登陆用户
        billNo: this.billNo, // 单号
        processCode: this.processCoding, // 流程编码
        variables: {
          billNo: this.billNo, // 单号
          // billRowId: this.detail.id, // id
          comment: this.textareaValue || "",
          status: val // 审批状态
        }
      }
      apiKernelFlowExternalBpm(url, params).then(res => {
        if (val === "APPROVED" && res.state === 100) {
          this.approvalLoading = false
          this.$message.success("同意成功")
          this.$emit('handle-success')
          this.reset()
        } else if (val === "REJECTED" && res.state === 100) {
          this.rejectLoading = false
          this.$message.success("驳回成功")
          this.$emit('handle-success')
          this.reset()
        } else {
          this.approvalLoading = false
          this.rejectLoading = false
          this.$message.error(res.msg)
        }
      }).catch(e => {
        this.approvalLoading = false
        this.rejectLoading = false
      })
    },
    // 同意
    handleRatify () {
      this.approvalLoading = true
      this.examineAndApprove("APPROVED")
    },
    // 驳回
    handleRefuse () {
      this.rejectLoading = true
      this.examineAndApprove("REJECTED")
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body {
  padding: 0;
  height: 195px;
  overflow-y: scroll;
}
.textarea-area{
  padding: 24px;
}
.footer {
  padding: 10px 16px;
  background: transparent;
  border-top: 1px solid #e8e8e8;
  border-radius: 0 0 4px 4px;
}
</style>
